// extracted by mini-css-extract-plugin
module.exports = {"row":"Evt3l","even":"XkQKI","highlight":"u58jT","edge":"_1sMsb","truncate":"_07+x9","inner":"kOqqj","breakWord":"NeDZQ","slim":"biAap"};